import React, { useEffect } from 'react';
import Preloader from '../components/layout/Preloader';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import HeroSlider from '../components/sections/HeroSlider';
import FeaturedFriends from '../components/sections/FeaturedFriends';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import Tours from '../components/sections/Tours';
import Gallery from '../components/sections/Gallery';
import Contact from '../components/sections/Contact';
import ScrollToTop from '../components/common/ScrollToTop';

const Home = () => {
  useEffect(() => {
    // Load external scripts if needed
    const loadScripts = () => {
      // Your existing JS scripts
    };
    loadScripts();
  }, []);

  return (
    <>
      <Preloader />
      <Navbar />
      <main>
        <HeroSlider />
        <FeaturedFriends />
        <About />
        <Services />
        <Tours />
        <Gallery />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
};

export default Home;